// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__18Rxk","alert":"SettungsInbox_alert__2ciCV"};